/**
 * @generated SignedSource<<393d0852ed03ab90736c5cd91c12ce93>>
 * @relayHash 7eae69585baaef03723add8e054843cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID acc3f7f2221983c9b372193365e61497048b1f0737ccef9007311d5f2b0e52a0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraProjectsTemplateListRightPanelContainerQuery } from './JiraProjectsTemplateListRightPanelContainerQuery.graphql';

const node: PreloadableConcreteRequest<JiraProjectsTemplateListRightPanelContainerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "acc3f7f2221983c9b372193365e61497048b1f0737ccef9007311d5f2b0e52a0",
    "metadata": {},
    "name": "JiraProjectsTemplateListRightPanelContainerQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
